__turbopack_context__.v({
  "freeBox": "PlasmicLinkCard-module__ki7NuW__freeBox",
  "root": "PlasmicLinkCard-module__ki7NuW__root",
  "text__abQc9": "PlasmicLinkCard-module__ki7NuW__text__abQc9",
  "text__icXsS": "PlasmicLinkCard-module__ki7NuW__text__icXsS",
  "text__oh2Jq": "PlasmicLinkCard-module__ki7NuW__text__oh2Jq",
  "text__yrMxa": "PlasmicLinkCard-module__ki7NuW__text__yrMxa",
});
